import * as React from "react";
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

function Header() {
  return (
    <section 
      className={cn(
        "relative min-h-[40vh] flex items-center justify-center text-center",
        "bg-cover bg-center bg-no-repeat"
      )}
      style={{
        backgroundImage: "url('https://cdn.builder.io/api/v1/image/assets/TEMP/4cccac2082d8b74ab5146595d9736c89454ec1fdce81d1d21fd97ae74dbf635c?placeholderIfAbsent=true&apiKey=7b6c1215e2f745adac7c4e4629a4a214')",
        backgroundBlendMode: 'overlay',
      }}
    >
      <div className="absolute inset-0 bg-primary/60 z-[1]" />
      <Container>
        <Stack spacing="md" align="center" className="relative z-[2] max-w-3xl mx-auto py-20">
          <Heading level="h1" className="text-3xl md:text-4xl lg:text-5xl font-bold text-white drop-shadow-lg">
            Recruitment Automated Screening Process
          </Heading>
          <Text size="lg" className="text-white/90 max-w-2xl">
            Streamline your hiring process with automated screening tools that save time, reduce bias, and help you focus on top talent with precision and efficiency.
          </Text>
        </Stack>
      </Container>
    </section>
  );
}

export default Header;